import { useMemo } from "react"
import useRawState from "./useRawState"

// boot ratings for a given boot-category index result: fetch all boot-recommendations
// plus that index category's ratings, then replace each rating's assessment IRI with
// the boot type it was recommended for. Shared by BootAdviceModal (on-demand, opened
// from the page) and PitchIndexPdfData (pre-staged for the exported PDF) so both stay
// in sync if this computation ever changes.
export default function useBootRatings(bootIndex) {
    const { data: allBootRecommendations, isBusy: recommendationsBusy } = useRawState(
        bootIndex ? '/api/current/boot-recommendations' : undefined
    )
    const { data: bootIndexCategory, isBusy: categoryBusy } = useRawState(
        bootIndex ? `/api/current/index-categories/${bootIndex.indexCategory.id}` : undefined
    )

    const bootRatings = useMemo(() => {
        if (!bootIndex || !allBootRecommendations || !bootIndexCategory) return []

        const recsOfThisIndexCategory = allBootRecommendations
            .filter(rec => rec.indexCategory === bootIndex.indexCategory['@id'])
        const assessmentsOfThisCategory = recsOfThisIndexCategory.map(rec => rec.assessment)

        return (bootIndexCategory.ratings ?? [])
            // only keep the ratings which occurred in our boot advice
            .filter(rating => assessmentsOfThisCategory.includes(rating.assessment['@id']))
            .map(rating => ({
                ...rating,
                assessment: recsOfThisIndexCategory.find(rec => rec.assessment === rating.assessment['@id']).bootType,
            }))
    }, [bootIndex, allBootRecommendations, bootIndexCategory])

    return { bootRatings, isBusy: recommendationsBusy || categoryBusy }
}
